import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, shareReplay} from 'rxjs/operators';

export interface AppVersion {
  version: string;
  revision: string;
  branch: string;
  buildDate: string;
}

const FALLBACK_VERSION: AppVersion = {
  version: 'dev',
  revision: 'unknown',
  branch: 'unknown',
  buildDate: null,
};

@Injectable({
  providedIn: 'root',
})
export class VersionService {

  private version$: Observable<AppVersion>;

  constructor(private http: HttpClient) {
  }

  getVersion(): Observable<AppVersion> {
    if (!this.version$) {
      this.version$ = this.http.get<AppVersion>('assets/version.json').pipe(
        catchError(() => of(FALLBACK_VERSION)),
        shareReplay(1)
      );
    }
    return this.version$;
  }
}
